import React from 'react'
import Breadcrumb from '../components/Breadcrumb'
import ServicesSidebar from '../components/ServicesSidebar'

function SocialMediaMarketing() {
  return (
   <>
   <Breadcrumb title={"Social Media Marketing"} tag = "Social Media Marketing"/>
       {/* <!--services details start--> */}
            <section className="service-details-section pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8">
                            <div className="service-details-wrap">
                                <img src="assets1/img/social.jpg" alt="services" className="img-fluid rounded"/>
                                <div className="services-detail-content mt-4">
                                    <h4>SOCIAL MEDIA MARKETING</h4>
                                    <p>Social media marketing is the process of creating content that you have tailored to the context of each individual social media platform in order to drive user engagement and sharing.</p>

                                    <p>You gaining traffic is only the result of social media marketing. What do you do to get that result? Create content that works well on each platform.</p>

                                    <p>Social media marketing is a powerful way for businesses of all sizes to reach prospects and customers. Your customers are already interacting with brands through social media, and if you're not speaking directly to your audience through social platforms like Facebook, Twitter, Instagram, and Pinterest, you're missing out! Great marketing on social media can bring remarkable success to your business, creating devoted brand advocates and even driving leads and sales.</p>

                                    <div className="row mt-5">
                                        <div className="col-md-6">
                                            <div className="img-wrap">
                                                <img src="assets1/img/social1.jpg" alt="services" className="img-fluid"/>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="list-unstyled tech-feature-list">
                                                <li className="py-1 pb-3">Social Media Marketing includes:</li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Local Search Marketing</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Analytics & Reporting</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Mobile Search</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Keyword Analysis</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Paid Search</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Link Building</strong></li>
                                               
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <ServicesSidebar />
                    </div>
                </div>
            </section>
            {/* <!--services details end--> */}
   </>
  )
}

export default SocialMediaMarketing
